{
  "version": 1,
  "asset_id": "19a666f6-0e85-4f35-9198-0fb23c623ed2",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/19a666f6-0e85-4f35-9198-0fb23c623ed2/how-it-works-hero-1600.webp",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/19a666f6-0e85-4f35-9198-0fb23c623ed2/how-it-works-hero-1600.webp",
  "original_filename": "how-it-works-hero-1600.webp",
  "size": 109476,
  "content_type": "image/webp",
  "created_at": "2026-07-22T22:52:00Z"
}
